
import axios from "axios";

const createClient = (data) => {
  return axios.post(`${process.env.REACT_APP_API_BASE_URL}/user/create`, data).then((response) => {
    return response.data;
  });
};
const allClients = (page, size) => {
  //const user = JSON.parse(localStorage.getItem("user"));
  return axios
    .get(`${process.env.REACT_APP_API_BASE_URL}/user/allClients?page=${page}&size=${size}&tenant=${JSON.parse(localStorage.getItem("user")).TenantId}`)
    .then((response) => {
      return response.data;
    });
};
/*const allClients = (page,size) => {
  return axios1.get(`/api/users/allClients?page=${page}&size=${size}`).then((response) => {
    return response.data;
  });
};
*/
const findOne = (userId) => {
  return axios.get(`${process.env.REACT_APP_API_BASE_URL}/user/findOne/${userId}`).then((response) => {
    return response.data;
  });
};

const findManagersByTenant =async () => {
  return await axios.get(`${process.env.REACT_APP_API_BASE_URL}/user/managersByTenant`).then((response) => {
    console.log('AllUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUU',response.data)
    return response.data;
  });
};

const search = (searchString) => {
  return axios.post(`${process.env.REACT_APP_API_BASE_URL}/user/searchBy`, { searchString }).then((response) => {
    return response.data;
  });
};

const deleteClient = (userId) => {
  return axios.delete(`${process.env.REACT_APP_API_BASE_URL}/user/remove/${userId}`).then((response) => {
    return response.data;
  });
};

const deleteAll = () => {
  return axios.delete(`${process.env.REACT_APP_API_BASE_URL}/user/removeAll`).then((response) => {
    return response.data;
  });
};

const updateClient = (data, userId) => {
  return axios.put(`${process.env.REACT_APP_API_BASE_URL}/user/updateClient/${userId}`, data).then((response) => {
    return response.data;
  });
};

const putPassword = (userId, data) => {
  return axios.put(`${process.env.REACT_APP_API_BASE_URL}/user/putPassword/${userId}`, data).then((response) => {
    return response.data;
  });
};

const uploadExcel = (data) => {
  return axios.post(`${process.env.REACT_APP_API_BASE_URL}/user/excel/upload`, data).then((response) => {
    return response.data;
  });
};

const download = () => {
  return axios.get(`${process.env.REACT_APP_API_BASE_URL}/user/excel/download`).then((response) => {
    return response.data;
  });
};
const getlistgrilles = () => {
  return axios.get(`${process.env.REACT_APP_API_BASE_URL}/grille/list`).then((response) => {
    return response.data;
  });
};

const checkresetToken = async (token) => {
  const response =  await axios.get(
    `${process.env.REACT_APP_ADMIN_API_URL}/api/users/checkresetToken/${token}`
  );
  return response.status;
}

export default {
  createClient,
  allClients,
  search,
  deleteClient,
  deleteAll,
  findOne,
  updateClient,
  putPassword,
  uploadExcel,
  download,
  getlistgrilles,
  checkresetToken,
  findManagersByTenant,
};
